// Org-qualified key: with multi-org accounts the same browser can hold
// sessions against different orgs over time, and an unqualified key would
// point at another org's clinic after a switch.
const LAST_USED_CLINIC_KEY_PREFIX = 'synergrx.lastUsedClinicId';

function lastUsedClinicKey(orgId) {
    return `${LAST_USED_CLINIC_KEY_PREFIX}.${orgId}`;
}

export function getLastUsedClinic(orgId) {
    if (!orgId) {
        return null;
    }
    try {
        const clinicId = window.localStorage.getItem(lastUsedClinicKey(orgId));
        if (clinicId) {
            return clinicId;
        }
        // Migrate the pre-multi-org unqualified key into the first org that reads it,
        // then drop it. Callers already validate the value against the org's grants,
        // so a clinic from another org falls back the same way a missing key does.
        const legacyClinicId = window.localStorage.getItem(LAST_USED_CLINIC_KEY_PREFIX);
        if (legacyClinicId) {
            window.localStorage.setItem(lastUsedClinicKey(orgId), legacyClinicId);
            window.localStorage.removeItem(LAST_USED_CLINIC_KEY_PREFIX);
        }
        return legacyClinicId;
    } catch (e) {
        // ignore — storage disabled / privacy mode
        return null;
    }
}

export function setLastUsedClinic(orgId, clinicId) {
    // guard against '0'/undefined (logout / initial state) so we never persist a non-clinic
    if (orgId && clinicId && `${clinicId}` !== '0') {
        try {
            window.localStorage.setItem(lastUsedClinicKey(orgId), `${clinicId}`);
        } catch (e) {
            // ignore — quota / privacy mode
        }
    }
}
